"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.withHandler = void 0;
// Call a function in addition to handling popup state on click
const withHandler = (trigger, handler) => {
    return {
        ...trigger,
        onClick: (...args) => {
            handler?.();
            return trigger.onClick(...args);
        },
        onTouchStart: (...args) => {
            handler?.();
            return trigger.onTouchStart(...args);
        },
    };
};
exports.withHandler = withHandler;
